import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';

export default function ExternalLogin({ externalLoginUrl }) {
  return (
    <div className="text-center">
      <p>Sign in or Sign up with the Newmark Investor Marketplace to access this document</p>
      <Button href={externalLoginUrl} label="Access with NIM" />
    </div>
  );
}

ExternalLogin.propTypes = {
  externalLoginUrl: PropTypes.string.isRequired
};
